import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import entries from "@Object/entries";

export default function handleTransportTypes(data: SearchResultsRtkQueryResponseType) {
    const typesWithRoutes = entries(data.result.singleRoutes).filter(([_key, routes]) => (
        !!routes.length
    ))

    return {
        transportTypes: typesWithRoutes.map(([key, _routes]) => (key)),
        hasMoreThanOneTransportType: typesWithRoutes.length > 1,
    }
}